import Rest from '../services/rest'
import {store} from '../store/store'
/**
 * @typedef {PacatoYService}
 */
export default class PacatoYService{

    constructor() {
        this.resource = "/pacato"
        this.http = Rest.build(store.getters.token, this.resource);
    }

    static build() {
        return new this();
    }

    configs() {
        return this.http.get("/configs");
    }

    dashboard(){
        return this.http.get('/dashboard')
    }
}